module.exports = __webpack_public_path__ + "static/equipement_scolaire-d749b4895b676018052fd0780afa279e.png";